function Payment() {
  return <div>Welcome to the payments page</div>;
}

export default Payment;
